module.exports = __webpack_public_path__ + "static/img/no-message.fcbad8d1.png";